var map = {
	"./0.png": "cc71",
	"./1.png": "f989",
	"./10.png": "ed5b",
	"./2.png": "09cc",
	"./3.png": "237d",
	"./30.png": "7dc7",
	"./5.png": "34de",
	"./6.png": "5206"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef6e";